import { render, staticRenderFns } from "./AgreeLegalConditions.vue?vue&type=template&id=0c937d6d&"
import script from "./AgreeLegalConditions.vue?vue&type=script&lang=js&"
export * from "./AgreeLegalConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports